import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Preloader from './components/Preloader';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ServicePage from './pages/ServicePage';
import CompanyPage from './pages/CompanyPage';
import ContactPage from './pages/ContactPage';
import RecruitPage from './pages/RecruitPage';
import RecruitApplyPage from './pages/RecruitApplyPage';
import RecruitSurveyPage from './pages/RecruitSurveyPage';
import RecruitAssessmentPage from './pages/RecruitAssessmentPage';
import PrivacyPage from './pages/PrivacyPage';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const LocomotiveScroll = (await import('locomotive-scroll')).default;
      const _locomotiveScroll = new LocomotiveScroll(); // eslint-disable-line no-unused-vars

      setTimeout(() => {
        setIsLoading(false);
        document.body.style.cursor = 'default';
        window.scrollTo(0, 0);
      }, 2000);
    })();
  }, []);

  return (
    <Router>
      <div className="App">
        <AnimatePresence mode="wait">
          {isLoading && <Preloader />}
        </AnimatePresence>
        <Navigation />
        <main className="main-content">
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/service" element={<ServicePage />} />
            <Route path="/company" element={<CompanyPage />} />
            <Route path="/recruit" element={<RecruitPage />} />
            <Route path="/recruit/apply" element={<RecruitApplyPage />} />
            <Route path="/recruit/survey" element={<RecruitSurveyPage />} />
            <Route path="/recruit/assessment" element={<RecruitAssessmentPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
